import { getEnvironmentConfig } from '../utils/environment.config';

const envConfig = getEnvironmentConfig();

export const apiConfig = {
  baseURL: `${envConfig.backendUrl}`,
  debug: {
    version: '1.5',
    timestamp: new Date().toISOString(),
    environment: envConfig.name,
    backendUrl: envConfig.backendUrl,
    frontendUrl: envConfig.frontendUrl,
  },
};
